

<section>

    <div class="row justify-content-center confirmation-hide">
        <div class="col-md-12">
            <h1 class="text-center">Pelvic Mesh Class Actions</h1>
        </div>
        <div class="col-md-12">
            <h4 class="text-center">REGISTRATION CLOSED</h4>
        </div>
    </div>

    <div class="row justify-content-center confirmation-hide">
        <div class="col">
            <p>Registration for this class action has now closed. We will communicate directly with group members to provide further information about their compensation and entitlements.</p>
            <p class="mt-3">
                If you have any questions about the class action,  please contact our Mesh team on <a class="ca-phone-link" href="tel:1800 884 139" title="Call 1800 884 139"><span style="white-space: nowrap;">1800 884 139</span></a> or at
                <a title="Email prolapsemesh@shine.com.au" href="mailto:prolapsemesh@shine.com.au" class="svelte-1ciwxnh">prolapsemesh@shine.com.au</a>.
            </p>
        </div>
    </div>

</section>

